import Address from './Address'
import Country from './Country'
import Faq from './Faq'
import Order from './Order'
import State from './State'
import User from './User'
import XConfig from './XConfig'

const modelTypes = [
  Address,
  Country,
  Faq,
  Order,
  State,
  User,
  XConfig
]

const addModelsToDatabase = (database) => {
  modelTypes.forEach(m => database.register(m))
}

const addRecordsToStore = (recordsByEntity) => {
  Object.entries(recordsByEntity).forEach(([entity, data]) => {
    const Model = modelTypes.find(m => m.entity === entity)
    if (Model) {
      Model.insert({ data })
    }
  })
}

export {
  addModelsToDatabase,
  addRecordsToStore,
  Address,
  Country,
  Faq,
  Order,
  State,
  User,
  XConfig
}